'use client';

import { usePathname, useSearchParams, useRouter } from 'next/navigation';
import { ReactNode, useEffect } from 'react';
import { toast } from 'sonner';
import { success } from '@/lib/constants/success';
import { errors } from '@/lib/constants/errors';
import { useAuth } from '@/ui/context/AuthContext';

export default function LayoutClient({ children }: { children: ReactNode }) {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const router = useRouter();
    const { user, isLoading } = useAuth();

    // Only redirect if user is loaded and not complete
    // This prevents redirect loops during loading
    useEffect(() => {
        if (!isLoading && user && !user.completeUser && pathname !== "/account/complete") {
            router.push("/account/complete");
        }
    }, [user, isLoading, pathname, router]);

    useEffect(() => {
        const successParam = searchParams.get('success');
        const errorParam = searchParams.get('error');

        if (successParam) {
            toast.success(success[successParam]?.title, {
                description: success[successParam]?.message,
            });
        }

        if (errorParam) {
            toast.error(errors[errorParam]?.title, {
                description: errors[errorParam]?.message,
            });
        }
    }, [searchParams]);

    return (
        <>
            {children}
        </>
    );
}
